import {
  Flex, FlexColumn, InnerContentContainerDefault,
  PrimaryButton,
  useAuth,
  useIsAuth,
  useStickySafeNavigate,
} from '@equifinance/shared';
import styled from 'styled-components';
import { useEffect } from 'react';
import Page from '../components/Page';

const InnerContentContainer = styled(InnerContentContainerDefault)`
  padding: 0;
`;

const ForbiddenContainer = styled(Flex)`${({ theme }) => `
  width:100%;
  position: relative;
  min-height: 525px;
  background-color: ${theme.colours.neutral[10]};
`}`;

const ForbiddenContent = styled(FlexColumn)`${({ theme }) => `
  width:100%;
  position: relative;
  font-family: 'Montserrat';
  justify-content: center;
  align-items: center;
  z-index: 2;
  gap: ${theme.padding[5]};
`}`;

const Status = styled(FlexColumn)`${({ theme }) => `
  width:100%;
  justify-content: center;
  align-items: center;
  padding-bottom: ${theme.padding[5]};
`}`;

const StatusCode = styled.p`${({ theme }) => `
  font-size: ${theme.padding[11]};
  color: ${theme.colours.primary[1]};
  font-weight: ${theme.fontWeight.bolder};
`}`;

const StatusName = styled.p`${({ theme }) => `
  font-size: ${theme.fontSize[7]};
  color: ${theme.colours.neutral[2]};
  font-weight: ${theme.fontWeight.bold};
`}`;

const Button = styled(PrimaryButton)`
  width: 230px;
`;

const Block1 = styled.div`${({ theme }) => `
  width: 50%;
  height: 85%;
  position: absolute;
  background-color: ${theme.colours.primary[10]};
  clip-path: polygon(0% 0%, 50% 100%, 100% 100%, 50% 0%);
  z-index: 1;
  left: 5%;
`}`;

const Block2 = styled.div`${({ theme }) => `
  width: 30%;
  height: 25%;
  position: absolute;
  background-color: ${theme.colours.primary[10]};
  z-index: 1;
  top: 0;
  right: 0;
`}`;

const Block3 = styled.div`${({ theme }) => `
  width: 30%;
  height: 55%;
  position: absolute;
  background-color: ${theme.colours.primary[10]};
  z-index: 1;
  top: 30%;
  right: 0;
`}`;

function Forbidden() {
  const isAuth = useIsAuth();
  const { logout } = useAuth();
  const navigate = useStickySafeNavigate();

  useEffect(() => {
    if (!isAuth) {
      navigate('/login');
    }
  }, [isAuth]);

  return (
    <Page InnerContentContainer={InnerContentContainer}>
      <ForbiddenContainer>
        <Block1 />
        <Block2 />
        <Block3 />
        <ForbiddenContent>
          <Status>
            <StatusCode>403</StatusCode>
            <StatusName>Forbidden</StatusName>
          </Status>
          <Button onClick={() => { navigate('/'); }}>Return to homepage</Button>
          <Button onClick={logout}>Logout</Button>
        </ForbiddenContent>
      </ForbiddenContainer>
    </Page>
  );
}

export default Forbidden;
